<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3080_4956)">
<rect x="1.85" y="1.85" width="18.3" height="18.3" rx="9.15" stroke="currentColor" stroke-width="1.7"/>
<path d="M13.6353 14.8872C14.1219 14.8872 14.3653 14.8872 14.5153 14.6889C14.6654 14.4907 14.6098 14.2937 14.4986 13.8997C14.4599 13.7628 14.4132 13.628 14.3585 13.496C14.1759 13.055 13.9081 12.6542 13.5705 12.3167C13.233 11.9791 12.8322 11.7114 12.3912 11.5287C11.9501 11.346 11.4774 11.252 11 11.252C10.5226 11.252 10.0499 11.346 9.60889 11.5287C9.16785 11.7114 8.7671 11.9791 8.42954 12.3167C8.09198 12.6542 7.82421 13.055 7.64152 13.496C7.58686 13.628 7.54013 13.7628 7.50149 13.8997C7.3903 14.2937 7.33471 14.4907 7.48475 14.6889C7.6348 14.8872 7.87814 14.8872 8.36481 14.8872L13.6353 14.8872Z" fill="currentColor"/>
<circle cx="10.9951" cy="8.21021" r="1.84839" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3080_4956">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
